import { Injectable } from '@angular/core';
import { HcrService } from './hcr-service.service';
import { ClinicDataService } from './data-service/clinic-data-service';
import { RegisterApi } from './api-service/register/register-api';
import { TimeSectionRange } from './api-service/register/time-section-range';
import { UserCache } from './user-cache';
import { DateHelper } from '../shared/helpers/date-helper';
import { GroupBy } from '../shared/utilities';
import { EasyFormService } from './easy-form-service';
import { BaseConfig } from './base-config.service';
import { EasyNotificationService } from './easy-notification.service';
import { HttpMethodEnum } from '../enums/HttpMethodEnum';
import { TimeSecDesc, TimeSecEnum } from '../enums/TimeSecEnum';
import { L } from '@angular/cdk/keycodes';
import { ParameterApi } from './api-service/parameters/parameter-api';
import { MainLayoutService } from '../layout/services/main-layout.service';
/** 候診清單介接 */
@Injectable({
  providedIn: 'root'
})
export class MwsService {

  constructor(private hcrService:HcrService,
    private clinicData:ClinicDataService,
    private registerApi:RegisterApi,
    private paramApi:ParameterApi,
    private ezForm:EasyFormService,
    private notify:EasyNotificationService,
    private mainLayout:MainLayoutService
    
  ) { }
  async setting(){
    var sys001 = await this.clinicData.getParam('SYS101');
    var bc = BaseConfig.getConfig()
    var us = UserCache.getLoginUser();
    sys001.MWSManual
    var setting = await this.ezForm.show<MWSSetting>({
      title:'多媒體候診設定',
      msg:'',
      fields:{
        Url:{ name:'Url', value:sys001.MWSURL, type:'text', label:'IP', tip:'多媒體候診機IP:Port' },
        Manual:{ name:'Manual', value:sys001.MWSManual, type:'check', label:'手動叫號', tip:'啟用手動叫號時，患者選入不再自動叫號' },
        ClinicCode:{ name:'ClinicCode', value:us.Clinic.Code, type:'display', hidden:true, label:'機構代碼' },
        CompanyCode:{ name:'CompanyCode', value:us.CompanyCode, type:'display', hidden:true, label:'集團代碼' },
        ServiceAPI:{ name:'ServiceAPI', value:bc.webApi.visionAuthUrl, type:'display', hidden:true, label:'權限網址' },
        SignalRUrl:{ name:'SignalRUrl', value:bc.webApi.hisBaseUrl + 'chathub', type:'display', hidden:true, label:'推播網址' },

        
        //PatientWaitingNotifyForm:{ name:'PatientWaitingNotifyForm', value:false, type:'display', hidden:true, label:'機構代碼' },
      },
      btns:[{
        text:'更新清單',
        callback:async (d)=>{
          var reg001 = await this.clinicData.getParam('REG001');
          var defaultSec = TimeSectionRange.getSectionValue(new TimeSectionRange(reg001))
          var secRet = await this.ezForm.show({
            title:'更新候診清單',
            msg:'請選擇時段別',
            fields:{
              timeSec:{
                name:'timeSec',
                type:'radio',
                label:'時段',
                data:TimeSecDesc,
                value:defaultSec
              }
            },
            closeValue:()=>null
          })
          if(secRet!=null){
            await this.MWSRefresh(secRet.timeSec);
          }
        }
      }],
      // Url測試
      beforeSubmit:async (d)=>{
        this.mainLayout.showLoader();
        var ret = await this.test(d.Url);
        if(!ret){
          this.notify.showWarning('連線測試失敗，請確定IP/PORT正確並且多媒體候診系統以系統管理員權限開啟');
        }
        this.mainLayout.hideLoader();
        return ret;
      },
      closeValue:()=>null
    });
    if(setting){
      var url = setting.Url// '192.168.11.119:8919';
      sys001.MWSURL = url;
      sys001.MWSManual = setting.Manual;
      try{  
        await this.paramApi.UpdateParamGroup('SYS101',sys001);
      }catch(e){
        this.notify.showError('系統參數更新失敗')
      }
      try{  
        var ret = await this.hcrService.SendFromUrl(`http://${url}/init`,JSON.stringify({
          ServiceAPI:bc.webApi.visionAuthUrl,
          SignalRUrl: bc.webApi.hubUrl + 'chathub',
          CompanyCode:us.CompanyCode,
          ClinicCode:us.Clinic.Code,
          // PatientWaitingNotifyForm:false,
          // CallCurrentSerialNo:false,
          // CallNextSerialNo:false,
          // AllowCallPassdNumber:false
        }),'application/json','utf8',{
          DevKey:'vision'
        });
        if(ret.Successed){
          this.notify.showSuccess('設定完成')
        }
      }catch(e){
        this.notify.showError(e)
      }
    }

        
  }
  async test(url:string){
    try{
      var ret = await this.hcrService.GetFromUrl(`http://${url}/test`,{
        DevKey:'vision'
      });
      return ret.Successed;
    }catch(ex){
      this.notify.showError(ex)
      return false;
    }
  }
  async MWSRefresh(timeSec:TimeSecEnum){
    try{
      await this.registerApi.MWSRefresh(timeSec,false);
      this.notify.showSuccess('操作成功')
    }catch(e){
      this.notify.showError(e)
    }
  }
  async MWSCall(timeSec:TimeSecEnum){
    try{
      await this.registerApi.MWSRefresh(timeSec,true);
      this.notify.showSuccess('操作成功')
    }catch(e){
      this.notify.showError(e)
    }
  }
}

export interface MWSSetting{
  Url:string;
  Manual:boolean;
  PatientWaitingNotifyForm:boolean;
  CallCurrentSerialNo:boolean;
  CallNextSerialNo:boolean;
  AllowCallPassdNumber:boolean;
  
  ServiceAPI:string;
  SignalRUrl:string;
  CompanyCode :string;
  ClinicCode:string;
}

export interface MWSWaitingList{
  ClinicId:string ;
  ClinicName:string ;
  RequestDateTime:string ;
  /** 診間 */
  ClinicRoom: MWSClinicRoom;
}

export interface MWSClinicRoom{
  /** 診間代碼( 顯示用 {n:00}診) 識別每一個區域候診清單診別用 數字 */
  RoomId:number
  /** 診間名稱 有填優先顯示這個 */
  RoomName:string;
  /** 醫師名稱 */
  DoctorName:string;
  /** 目前號碼 */
  SerialNo:string;
  /** 手動叫號，"Y" / ""(或其他) */
  AHDCALL:string;
  
  /** 候診 非手動叫號下 MWS自動依照 看診中=>保留=>候診=>預約=>領藥 進行優先排序 */
  Patients:MWSPatient[]
  // 以下沒用到
  Shift:string;
  WatingCount:number
}
export interface MWSPatient{
  /** 看診號 */
  seqno:string;
  /** 姓名 */
  patientname:string;
  /** 狀態 1:看診 A:候診 E:預約 D:保留 G:領藥 */
  statuscode:string;
  // 沒用到 MWS中自動補完
  queueno:number;
  // 沒用到
  patientid:string;
  // 沒用到
  patientsex:number
}